import apiClient from '../apiClient';
import { POST_USER_PROFILE_URL } from '../apiUrl';

const postUserProfileApi = data => {
  return apiClient.post(POST_USER_PROFILE_URL, data);
};

export default postUserProfileApi;
